import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Test from "./components/Test";
import { SuccessPage } from "./components/SuccessPage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />}></Route>
      <Route path="Success" element={<SuccessPage />}></Route>
      <Route path="Success/:OrderId" element={<SuccessPage />}></Route>
      <Route
        path="Success/:OrderId/:ReferenceNumber"
        element={<SuccessPage />}
      ></Route>

      <Route path="test" element={<Test />}></Route>
    </Routes>
  </BrowserRouter>
  //</React.StrictMode>
);
